<template>
  <b-form>
    <div
      class="row mb-1 pb-3 mb-3 border-bottom g-0"
      style="--bs-border-color: black"
    >
      <div class="col-md-12 d-flex align-items-center">
        <span class="fw-bold">Realisasi Pemanfaatan Ruang Laut</span>
      </div>
    </div>

    <legend v-if="jenis_kegiatan === 'Berusaha'" class="fw-bold text-gray">
      Realisasi luas/panjang pemanfaatan ruang laut, dalam hal perizinan
      berusaha yang diterbitkan
    </legend>
    <legend v-if="jenis_kegiatan === 'Non Berusaha'" class="fw-bold text-gray">
      Realisasi luas/panjang pemanfaatan ruang laut, dalam hal perizinan non
      berusaha yang diterbitkan
    </legend>
    <div :class="['row mb-3']">
      <div class="col-md-6">
        <div class="row">
          <div class="col">
            <label>Luas (ha) <span class="text-danger">*</span></label>
            <i
              class="fa fa-info-circle ml-1"
              v-b-tooltip.hover.topright="'Jika tidak ada isi dengan 0'"
            />
            <div class="input-units">
              <b-form-input
                v-model="form.luas"
                id="luas"
                v-mask="decimalMask(form.luas)"
                v-validate="'required'"
                name="Luas/Panjang"
                :class="{
                  input: true,
                  'is-danger': errors.has('Luas/Panjang'),
                }"
                :disabled="is_selesai"
                style="background-color: white"
              ></b-form-input>
              <div class="text-units">
                <span>{{ form.luas }}</span>
                <span> ha</span>
              </div>
            </div>
            <span class="text-danger" v-if="errors.has('Luas/Panjang')">
              {{ errors.first('Luas/Panjang') }}
            </span>
          </div>
          <div class="col">
            <label>Panjang (km) <span class="text-danger">*</span></label>
            <i
              class="fa fa-info-circle ml-1"
              v-b-tooltip.hover.topright="'Jika tidak ada isi dengan 0'"
            />
            <div class="input-units">
              <b-form-input
                v-model="form.panjang"
                id="panjang"
                v-mask="decimalMask(form.panjang)"
                v-validate="'required'"
                name="Luas/Panjang"
                :class="{
                  input: true,
                  'is-danger': errors.has('Luas/Panjang'),
                }"
                :disabled="is_selesai"
                style="background-color: white"
              ></b-form-input>
              <div class="text-units">
                <span>{{ form.panjang }}</span>
                <span> km</span>
              </div>
            </div>
            <span class="text-danger" v-if="errors.has('Luas/Panjang')">
              {{ errors.first('Luas/Panjang') }}
            </span>
          </div>
        </div>
      </div>
      <div class="col-md-6">
        <label>Provinsi <span class="text-danger">*</span></label>
        <v-select
          v-model="selectedProvinsi"
          id="provinsi"
          :reduce="(data) => data.nama_provinsi"
          label="nama_provinsi"
          :options="dataProvinsi"
          multiple
          name="Provinsi"
          v-validate="'required'"
          :class="{
            input: true,
            'pe-none': is_selesai,
            'is-danger': errors.has('Provinsi'),
          }"
        />
        <span class="text-danger" v-if="errors.has('Provinsi')">
          {{ errors.first('Provinsi') }}
        </span>
      </div>
      <div class="col-md-6 mt-3">
        <label>Nama Perairan/Laut <span class="text-danger">*</span></label>
        <b-form-textarea
          name="Nama Perairan/Laut"
          v-validate="'required'"
          v-model="form.nama_perairan"
          id="nama_perairan"
          rows="3"
          :disabled="is_selesai"
          style="background-color: white"
        ></b-form-textarea>
        <span class="text-danger" v-if="errors.has('Nama Perairan/Laut')">
          {{ errors.first('Nama Perairan/Laut') }}
        </span>
      </div>
      <div v-if="jenis_kegiatan === 'Berusaha'" class="col-md-6 mt-3">
        <label>Kode KBLI <span class="text-danger">*</span></label>
        <v-select
          v-model="selectedKBLI"
          id="kode_kbli"
          :reduce="(data) => data.kode"
          label="kode_deskripsi"
          :options="dataKBLI"
          multiple
          name="Kode KBLI"
          v-validate="'required'"
          :class="{
            input: true,
            'pe-none': is_selesai,
            'is-danger': errors.has('Kode KBLI'),
          }"
        />
        <span class="text-danger" v-if="errors.has('Kode KBLI')">
          {{ errors.first('Kode KBLI') }}
        </span>
      </div>
      <div class="col-md-6 mt-3">
        <label>Kedalaman (m) <span class="text-danger">*</span></label>
        <div class="input-units">
          <b-form-input
            v-model="form.kedalaman"
            id="kedalaman"
            v-mask="decimalMask(form.kedalaman)"
            v-validate="'required'"
            name="Kedalaman"
            :class="{
              input: true,
              'is-danger': errors.has('Kedalaman'),
            }"
            :disabled="is_selesai"
            style="background-color: white"
          ></b-form-input>
          <div class="text-units">
            <span>{{ form.kedalaman }}</span>
            <span> m</span>
          </div>
        </div>
        <span class="text-danger" v-if="errors.has('Kedalaman')">
          {{ errors.first('Kedalaman') }}
        </span>
      </div>
      <div class="col-md-6 mt-3">
        <label
          >Detail Kegiatan {{ jenis_kegiatan }}
          <span class="text-danger">*</span></label
        >
        <b-form-input
          v-model="form.detail_kegiatan"
          id="detail_kegiatan"
          v-validate="'required'"
          name="Detail Kegiatan"
          :class="{
            input: true,
            'is-danger': errors.has('Detail Kegiatan'),
          }"
          :disabled="is_selesai"
          style="background-color: white"
        ></b-form-input>
        <span class="text-danger" v-if="errors.has('Detail Kegiatan')">
          {{ errors.first('Detail Kegiatan') }}
        </span>
      </div>
      <div class="col-md-6 mt-3">
        <label>Waktu Realisasi <span class="text-danger">*</span></label>
        <DatePicker
          id="waktu_realisasi"
          lang="en"
          :placeholder="waktu_realisasi"
          input-class="form-control"
          @change="
            (val) => {
              this.waktu_realisasi = val.toLocaleDateString('en-GB')
              this.form.waktu_realisasi = formatDate(val, 'YYYY-MM-DD')
              this.errors.remove('Waktu Realisasi')
            }
          "
          :class="['w-100', { 'pe-none': is_selesai }]"
        >
          <i class="fa fa-calendar-o" slot="calendar-icon" />
        </DatePicker>
        <span class="text-danger" v-if="errors.has('Waktu Realisasi')">
          {{ errors.first('Waktu Realisasi') }}
        </span>
      </div>
    </div>
    <div class="row mb-1 pb-3 border-bottom g-0"></div>

    <div class="row">
      <div class="col-4 col-xl-5 mt-3">
        <span>Koordinat</span>
      </div>
      <div class="col-8 col-xl-7 mt-3">
        <div class="row">
          <div>
            <small
              >Format file: XLSX, Ukuran maksimal: 5MB
              <span class="text-danger">*</span></small
            >
          </div>
          <div class="col-4">
            <b-form-file
              v-model="form.file_kordinat"
              id="file_kordinat"
              plain
              class="form-control"
              name="Koordinat"
              accept=".xls, .xlsx"
              @change="
                (e) => {
                  checkFileSize(e, 'file_kordinat')
                  errors.remove('Koordinat')
                }
              "
              :disabled="is_selesai"
            ></b-form-file>
          </div>
          <div class="col-8 d-flex">
            <a
              v-if="!is_selesai"
              :class="[
                'btn btn-primary mr-2 text-white',
                { disabled: form.file_kordinat === null },
              ]"
              @click="uploadFile('file_kordinat')"
            >
              <i class="fa fa-cloud-upload" />
              Unggah
            </a>
            <a
              :class="{
                'btn btn-success': true,
                disabled: file_kordinat === null,
              }"
              :href="file_kordinat"
              target="_blank"
            >
              <i class="fa fa-download" />
              Unduh
            </a>
            <a
              v-if="!is_selesai"
              class="btn btn-info mr-2 text-white ml-2"
              :href="baseapi + '/template_dokumen/format_import_kordinat.xlsx'"
              ><i class="fa fa-file-o"></i> Template</a
            >
          </div>
        </div>
        <span class="text-danger" v-if="errors.has('Koordinat')">
          {{ errors.first('Koordinat') }}
        </span>
        <span class="text-danger" v-if="errors.has('file_kordinat', 'custom')">
          {{ errors.first('file_kordinat', 'custom') }}
        </span>
      </div>
      <div class="col-4 col-xl-5 mt-3">
        <span>Dokumentasi kegiatan bangungan/instalasi di lokasi</span>
      </div>
      <div class="col-8 col-xl-7 mt-3">
        <div class="row">
          <div>
            <small
              >Format file: PDF, Ukuran maksimal: 5MB
              <span class="text-danger">*</span></small
            >
          </div>
          <div class="col-4">
            <b-form-file
              v-model="form.file_dokumentasi_kegiatan_bangunan"
              id="file_dokumentasi_kegiatan_bangunan"
              plain
              class="form-control"
              name="Dokumentasi Kegiatan"
              accept=".pdf"
              @change="
                (e) => {
                  checkFileSize(e, 'dokumentasi-kegiatan')
                  errors.remove('Dokumentasi Kegiatan')
                }
              "
              :disabled="is_selesai"
            ></b-form-file>
          </div>
          <div class="col-8 d-flex">
            <a
              v-if="!is_selesai"
              :class="[
                'btn btn-primary mr-2 text-white',
                { disabled: form.file_dokumentasi_kegiatan_bangunan === null },
              ]"
              @click="uploadFile('file_dokumentasi_kegiatan_bangunan')"
            >
              <i class="fa fa-cloud-upload" />
              Unggah
            </a>
            <a
              :class="{
                'btn btn-success': true,
                disabled: file_dokumentasi_kegiatan_bangunan === null,
              }"
              :href="file_dokumentasi_kegiatan_bangunan"
              target="_blank"
            >
              <i class="fa fa-download" />
              Unduh
            </a>
          </div>
        </div>
        <span class="text-danger" v-if="errors.has('Dokumentasi Kegiatan')">
          {{ errors.first('Dokumentasi Kegiatan') }}
        </span>
        <span
          class="text-danger"
          v-if="errors.has('dokumentasi-kegiatan', 'custom')"
        >
          {{ errors.first('dokumentasi-kegiatan', 'custom') }}
        </span>
      </div>
    </div>

    <div class="mt-5 fw-bold">
      Note: tanda (<span class="text-danger">*</span>) wajib diisi
    </div>
  </b-form>
</template>

<script>
import vSelect from 'vue-select'
import axios from 'axios'
import { decimalMask } from '../../helper/validationHelper'
import Swal from 'sweetalert2'
import DatePicker from 'vue2-datepicker'
import { formatDate } from '../../helper/helpernew'

export default {
  components: {
    vSelect,
    DatePicker,
  },
  data() {
    return {
      baseapi: localStorage.getItem('baseapi'),
      user: JSON.parse(localStorage.getItem('user')),
      form: {
        luas: '0',
        panjang: '0',
        provinsi: '',
        nama_perairan: '',
        kode_kbli: '',
        kedalaman: '0',
        detail_kegiatan: '',
        waktu_realisasi: null,
        file_kordinat: null,
        file_dokumentasi_kegiatan_bangunan: null,
      },
      waktu_realisasi: 'dd/mm/yyyy',
      is_selesai: false,
      file_kordinat: null,
      file_dokumentasi_kegiatan_bangunan: null,
      jenis_kegiatan: null,
      selectedProvinsi: [],
      selectedKBLI: [],
      dataProvinsi: [],
      dataKBLI: [],
      dataKegiatan: [
        { value: 1, text: 'Berusaha' },
        { value: 0, text: 'Non Berusaha' },
      ],
    }
  },
  mounted() {
    this.getProvinsi()
    this.getKBLI()
    this.loadLaporanTahunan()
  },
  methods: {
    decimalMask,
    formatDate,

    uploadFile(field) {
      this.$loading(true)
      const formData = new FormData()
      formData.append(field, this.form[field])

      axios
        .post(
          this.baseapi + `api/laporan_tahunan/${this.$route.query.id_laporan}`,
          formData,
          {
            headers: {
              'Content-Type': 'multipart/form-data',
              Authorization: `Bearer ` + this.user.accessToken,
            },
          }
        )
        .then(async (res) => {
          this.$toasted.success('Berhasil Diunggah')
          this[field] = res.data.data[field]
          this.form[field] = null
        })
        .catch((err) => {
          this.$toasted.danger('Gagal Diunggah')
        })
        .finally(() => {
          this.$loading(false)
        })
    },

    async nextForm() {
      if (this.is_selesai) {
        return true
      }

      this.form.provinsi = this.multipleSelectToString(this.selectedProvinsi)
      this.form.kode_kbli = this.multipleSelectToString(this.selectedKBLI)

      if (this.form.waktu_realisasi === null) {
        this.errors.add({
          field: 'Waktu Realisasi',
          msg: 'Waktu Realisasi wajib diisi',
        })
      }

      if ((await this.$validator.validateAll()) && !this.errors.any()) {
        this.$loading(true)
        try {
          const formData = new FormData()
          // prettier-ignore
          {
            formData.append('realisasi_luas', parseFloat(this.form.luas))
            formData.append('realisasi_panjang', parseFloat(this.form.panjang))
            formData.append('provinsi', this.form.provinsi)
            formData.append('nama_perairan', this.form.nama_perairan)
            formData.append('kode_kbli', this.form.kode_kbli)
            formData.append('kedalaman', parseFloat(this.form.kedalaman))
            formData.append('detail_kegiatan', this.form.detail_kegiatan)
            formData.append('waktu_realisasi', this.form.waktu_realisasi)
          }
          await axios.post(
            this.baseapi +
              `api/laporan_tahunan/${this.$route.query.id_laporan}`,
            formData,
            {
              headers: {
                'Content-Type': 'multipart/form-data',
                Authorization: `Bearer ` + this.user.accessToken,
              },
            }
          )

          await this.loadLaporanTahunan()
          if (this.file_kordinat === null) {
            this.errors.add({
              field: 'Koordinat',
              msg: 'File Koordinat wajib diisi',
            })
          } else {
            this.errors.remove('Koordinat')
          }
          if (this.file_dokumentasi_kegiatan_bangunan === null) {
            this.errors.add({
              field: 'Dokumentasi Kegiatan',
              msg: 'File Dokumentasi Kegiatan wajib diisi',
            })
          } else {
            this.errors.remove('Dokumentasi Kegiatan')
          }
          if (this.errors.any()) {
            this.$loading(true)
            return false
          }
          Swal.fire(
            'Berhasil',
            'Realisasi Pemanfaatan Ruang Laut Laporan Tahunan tersimpan',
            'success'
          )
          this.$loading(false)
          return true
        } catch (error) {
          this.$loading(false)
          Swal.fire('Gagal', 'Terjadi kesalahan', 'error')
          return false
        }
      } else {
        return false
      }
    },

    loadLaporanTahunan() {
      if (!this.$route.query.id_laporan) {
        return
      }

      this.$loading(true)
      axios
        .get(
          `${this.baseapi}api/laporan_tahunan/${this.$route.query.id_laporan}`,
          {
            headers: {
              Authorization: `Bearer ` + this.user.accessToken,
            },
          }
        )
        .then((res) => {
          const data = res.data.data
          this.jenis_kegiatan = data.jenis_kegiatan
          this.is_selesai =
            data.status_laporan !== null &&
            data.status_laporan !== 'Draft' &&
            data.status_laporan !==
              'Komentar/Informasi terhadap Penyampaian Laporan Tahunan'
          this.form = {
            luas: String(data.realisasi_luas) || '0',
            panjang: String(data.realisasi_panjang) || '0',
            nama_perairan: data.nama_perairan || '',
            kedalaman: String(data.kedalaman) || '0',
            detail_kegiatan: data.detail_kegiatan || '',
            waktu_realisasi: data.waktu_realisasi || null,
            file_kordinat: null,
            file_dokumentasi_kegiatan_bangunan: null,
          }
          this.waktu_realisasi =
            data.waktu_realisasi !== null
              ? formatDate(data.waktu_realisasi, 'DD/MM/YYYY')
              : 'dd/mm/yyyy'
          this.file_kordinat = data.file_kordinat
          this.file_dokumentasi_kegiatan_bangunan =
            data.file_dokumentasi_kegiatan_bangunan
          // this.selectedProvinsi = data.provinsi || []
          if (data.provinsi.length > 0) {
            this.selectedProvinsi = data.provinsi
          }
          this.selectedKBLI = data.kode_kbli || []
        })
        .catch((err) => {
          Swal.fire('Gagal', 'Terjadi kesalahan saat mengambil data', 'error')
        })
        .finally(() => {
          this.$loading(false)
        })
    },

    getProvinsi() {
      axios
        .get(this.baseapi + 'api/provinsi?sort=id,ASC', {
          headers: {
            Authorization: `Bearer ` + this.user.accessToken,
          },
        })
        .then((response) => {
          this.dataProvinsi = response.data.data
        })
    },

    getKBLI() {
      axios
        .get(this.baseapi + 'api/kbli', {
          headers: {
            Authorization: `Bearer ` + this.user.accessToken,
          },
        })
        .then((response) => {
          this.dataKBLI = response.data.data
        })
    },

    multipleSelectToString(data) {
      let str = ''
      for (let i = 0; i < data.length; i++) {
        if (i !== 0) str += '||'
        str += data[i]
      }
      return str
    },

    checkFileSize(e, field) {
      const file = e.target.files[0]
      const maxSize = 5 * 1024 * 1024

      if (file && file.size > maxSize) {
        this.errors.add({
          field: field,
          msg: 'Ukuran file maksimal 5MB',
          scope: 'custom',
        })
      } else {
        this.errors.remove(field, 'custom')
      }
    },
  },
  watch: {},
}
</script>
